/* global angular */
( function () {
	'use strict';

	function ObsMath ( $modal, templateHolder, authService ) {
		var self = this;

		var modalConfig = {
			'templateUrl'  : '/templates/components/math/interface/math-io.html',
			'controller'   : 'MathInterface',
			'controllerAs' : 'vm',
			'keyboard'     : false,
			'windowClass'  : 'math-modal',
			'size'         : 'lg',
			'backdrop'     : 'static',
			'resolve'      : {
				'groupModel' : function () {
					return {
						'itemList' : self.itemList,
						'prefix'   : self.prefix,
						'itemKey'  : self.itemKey,
						'nameKey'  : self.nameKey,
						'viewMode' : self.viewMode || authService.isViewOnlyMode(),
						'score'    : self.score,

						'formulaName' : self.formulaName
					};
				}
			}
		};

		function replaceTemplateFormula ( oldGroupId, newGroupId, templateModel ) {
			if ( ( templateModel.formula || '' ).indexOf( oldGroupId ) > -1  ) {
				templateModel.formula = ( templateModel.formula || '' ).split( oldGroupId ).join( newGroupId );
			}
		}

		function viewFormula () {
			var modalInstance = $modal.open( modalConfig );
			var copiedModel   = angular.copy( self.itemList );

			self.itemList.formula = self.itemList.formula || '';

			if ( self.itemList.formula === '0' ) {
				self.itemList.formula = '';
			}

			modalInstance.result.then( function () {
				copiedModel = angular.copy( self.itemList );
			}, function () {
				if ( copiedModel.id !== self.itemList.id ) {
					templateHolder.alter( function ( templateModel ) {
						replaceTemplateFormula( self.itemList.id, copiedModel.id, templateModel );
					} );

					self.itemList.id = copiedModel.id;
				}

				self.itemList.formula = copiedModel.formula;

				if ( copiedModel.rubric ) {
					self.itemList.rubric = copiedModel.rubric;
				} else {
					delete self.itemList.rubric;
				}
			} );
		}

		self.viewFormula = viewFormula;
	}

	angular
		.module( 'app.components' )
		.controller( 'ObsMathCtrl', ObsMath );

	ObsMath.$inject = [ '$modal', 'templateHolder', 'authService' ];
} )( );
